import { css } from '@genesislcap/web-core';
import { cancelButtonBg, labelStyles, closeIconStyles } from '../../../styles';
import { sharedMuniGridStyles } from '../deals.styles';

export const dealSeriesStyles = css`
  :host {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    position: relative;
  }
  ${labelStyles}

  .deal-grid {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;

    .deal-grid-actions {
      display: flex;
      padding: 10px;
      flex: 0;
      gap: 10px;
    }

  }

  .deal-grid-container--capped {
    flex: 1;
    min-height: 0;
    overflow: hidden;
  }

  .deal-grid-container--capped rapid-grid-pro {
    display: block;
    height: 100%;
  }

  .deal-grid-container--capped rapid-grid-pro::part(grid) {
    height: 100%;
  }

  ${sharedMuniGridStyles}

  .conditions-popup {
    background: #1f2126;
    border: 1px solid ${cancelButtonBg};
    border-radius: 6px;
    position: absolute;
    top: 0;
    right: 0;
    min-width: 760px;
    padding: 10px;
    max-height: calc(100% - 10px);
    box-sizing: border-box;
    overflow: hidden;
    margin-bottom: 10px;
    display: flex;
    flex-direction: column;

    .conditions-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      flex-shrink: 0;

      > div:first-child {
        flex: 1;
      }

    }

    .conditions-form {
      flex: 1;
      overflow-x: visible;
      overflow-y: auto;
    }
  }

  .conditions-summary-cell {
    white-space: normal;
    overflow: visible;
    text-overflow: unset;
    line-height: 1.2;
    padding: 4px 0;
  }

  ${closeIconStyles}
`;
